const _require = require('../lib/evaluateSource'),
  evaluateSource = _require.evaluateSource;

/**
  * @function evalute - evaluate validateFormTitleBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const title = content.title;
  if (title === undefined || title.length === 0) {
    return 'Title cannot be empty';
  }
  const formTypeIdentifier = await evaluateSource(source.formTypeIdentifier, content, parentContentPath, transientContext, nativeFunctions);
  const querySource = {
    type: 'queryEntityBehavior',
    entityName: 'Form',
    equals: {
      'formType/identifier': formTypeIdentifier
    },
    equalsNoneOf: {
      id: [content.id]
    },
    ifContent: {
      atPath: 'title',
      equals: title
    }
  };
  const existing = await evaluateSource(querySource, content, parentContentPath, transientContext, nativeFunctions);
  if (existing.length > 0) {
    return 'Title must be unique';
  }
  return undefined;
};
module.exports = {
  evaluate
};